export const Color ={
    primaryOrange:"#FF7360",
    white:'#FFFFFF',
    black: "#302124",
}